var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsNoteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_sns_note_filled_svg__clip0_37861_449458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.99 2.057H7.964a5.907 5.907 0 00-5.906 5.907V23.99a5.907 5.907 0 005.906 5.907h16.028a5.907 5.907 0 005.907-5.907V7.964a5.907 5.907 0 00-5.907-5.907z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.906 10.048c2.34 0 5.543-.12 7.844-.057 3.084.08 4.248 1.426 4.288 4.742.04 1.88 0 7.253 0 7.253h-3.34c0-4.703.017-5.48 0-6.963-.04-1.306-.409-1.925-1.414-2.045-1.062-.119-4.038-.017-4.038-.017v9.03h-3.34V10.049z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.99 3.057H7.964a4.907 4.907 0 00-4.906 4.907V23.99a4.907 4.907 0 004.906 4.907h16.028a4.907 4.907 0 004.907-4.907V7.964a4.907 4.907 0 00-4.907-4.907zm-16.027-1h16.028a5.907 5.907 0 015.907 5.907V23.99a5.907 5.907 0 01-5.907 5.907H7.963a5.907 5.907 0 01-5.906-5.907V7.964a5.907 5.907 0 015.906-5.907z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_sns_note_filled_svg__clip0_37861_449458"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}

export default SvgIconSnsNoteFilled;